import { styled, Box } from '@mui/material';

export const SongsLibraryContainer = styled(Box)({
  width: '100%',
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'scroll',
});

export const SongListWrapper = styled(Box)(() => ({}));
